// app/javascript/controllers/gender_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["select", "input", "inputLabel"]
    static values = {
        custom: { type: String, default: "__custom__" }
    }

    connect() {
        this.hideCustomInput()
    }

    selectionChanged() {
        const selectedGender = this.selectTarget.value

        if (selectedGender === this.customValue) {
            this.inputTarget.value = ""
            this.inputLabelTarget.classList.remove("hidden")
            this.inputTarget.classList.remove("hidden")
            this.inputTarget.required = true
            this.inputTarget.focus()
            return
        }

        this.inputTarget.value = selectedGender
        this.hideCustomInput()
    }

    hideCustomInput() {
        this.inputLabelTarget.classList.add("hidden")
        this.inputTarget.classList.add("hidden")
        this.inputTarget.required = false
    }
}
